import './tradeDetails.scss';

let tablesReady = false;
let lang = document.documentElement.lang;
let btn_text = require('./td.json')[lang];


const  preventBodyScroll = () => {
    document.body.classList.toggle('no-scroll-td');
}

function setTDtable(){
     tablesReady = true;
    let table_content = require('./table.json');

    let table_titles = table_content[lang];

    let tdTableArr = window.td_tables;
    let td_wrapper = document.getElementById('td-tables');

    if(tdTableArr && tdTableArr.length > 0 && td_wrapper){
        
        tdTableArr.forEach( table => {
            
            let rows = '';

            for (let p in table) {
                let cells = '';
                if(p !== 'img'){
                    table[p].forEach( td => {cells += `<td>${td}</td>`})
                    rows += `<tr><td class="title p">${table_titles[p]}</td>${cells}</tr>`; 
                }
            
            }
            let table_elem = `<div id="td-table-wrapper"><table>${rows}</table></div>`;

            
            if(table.img){
                table.img.forEach(i => { table_elem += `<img class="td-img" src="${i}"/>`; })
            }
            td_wrapper.innerHTML += table_elem;
                
        });
    }
}



function injectTD() {

    let div = document.createElement('div');
    div.innerHTML = `<br><span id='td-btn' class=''>${btn_text.trade_details}</span><br>`;

    let target = document.getElementById('last-paragraph');

    target.parentNode.insertBefore(div, target);
    target.parentNode.insertBefore(div, target.nextSibling);

    let td_btn = document.getElementById("td-btn");
    let total_page = document.getElementById("totalPage");
    let td = document.getElementById("td");

    td_btn.addEventListener('click', function () {

        !tablesReady && setTDtable();

        Object.assign(total_page.style, {
            display: "block",
            zIndex: "9"
        });

        td.style.display = "block";

        preventBodyScroll();


    });

    document.querySelectorAll(".td-close").forEach(function(item){
        item.addEventListener('click', function(event){

            total_page.style.display = "none";
            td.style.display = "none";

            preventBodyScroll();
        });
    });
}

function timeout() {
    if (document.getElementById("last-paragraph")) {
        injectTD();
    } else {
        setTimeout(timeout, 100);
    }
}

timeout();
